module.exports = __webpack_public_path__ + "static/Waldmeister-249b2e77cfbd27b1f3f0e5ecc9b52054.png";